import { MediaQueries, ThemeProps } from '@hhgtech/hhg-components'
import { Z_INDEX } from 'interfaces/constants'
import styled from 'styled-components'

export const StyledPopup = styled.div`
  position: absolute;
  right: 0;
  background-color: ${(props: ThemeProps) => props.theme.colors.white};

  &[data-animation='true'] {
    transition: all 0.5s ease-in-out;
  }

  &[data-open='true'] {
    z-index: ${Z_INDEX.headerContainerPopup + 2};
    top: 120%;
    opacity: 1;
    visibility: visible;
  }

  &[data-open='false'] {
    display: none;
  }

  &[data-type='lead'] {
    width: 332px;
    height: 460px;

    div {
      top: -15px;
      right: -15px;
    }
  }

  &[data-type='welcome'] {
    position: fixed;
    ${MediaQueries.tdDown} {
      width: 100%;
      height: 424px;
      bottom: 0;
      top: unset;
    }
    ${MediaQueries.tdUp} {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      min-height: 445px;
      max-width: 407px;
    }
  }

  &[data-type='due-date'] {
    position: fixed;
    ${MediaQueries.tdDown} {
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      bottom: 0;
      top: unset;
    }
    ${MediaQueries.tdUp} {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100vw;
      height: 55vw;
      max-height: 598px;
      max-width: 1080px;
      .close-button {
        top: 24px;
        right: 24px;
        img {
          width: 15px;
          height: 15px;
        }
      }
    }
  }

  .popup-content {
    z-index: 111;
    height: 100%;
  }

  &[data-type='form'] {
    width: 496px;
    height: 548px;
  }

  &[data-type='confirm'] {
    width: 380px;
    height: 252px;
  }

  &[data-type='profile'] {
    ${MediaQueries.mbUp} {
      border-radius: 6px;
      box-shadow: 0px 4px 8px
        ${(props: ThemeProps) => props.theme.colors.gray200};
      &:before {
        position: absolute;
        right: 11px;
        bottom: 100%;
        width: 0;
        height: 0;
        border: 0.5rem solid transparent;
        border-top: none;
        border-bottom-color: ${(props: ThemeProps) => props.theme.colors.white};
        content: '';
        filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(0, 0, 0, 0.1));
      }
      width: 368px;
    }

    ${MediaQueries.mbDown} {
      position: fixed;
      left: 0;
      top: 69px;
      width: 100%;
    }
  }

  .close-button {
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .popup-title {
    position: absolute;
    top: 0;
    left: 0;
    /* width: 32px;
    height: 32px; */
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
`

export const StyledPopupWrapper = styled.div`
  position: fixed;
  z-index: 150;
  top: 69px;
  left: 0;
  width: 100%;
  height: 100%;
  align-items: center;

  ${MediaQueries.tdUp} {
    &[data-type='welcome'] {
      background: rgba(38, 38, 38, 0.3);
    }
    &[data-type='due-date'] {
      background: rgba(38, 38, 38, 0.3);
    }
    &[data-type!='welcome'] {
      background-color: transparent;
    }
  }

  ${MediaQueries.tdDown} {
    background: rgba(38, 38, 38, 0.3);
  }

  &[data-open='false'] {
    display: none;
  }

  &[data-type='welcome'] {
    top: 0;
  }

  &[data-type='due-date'] {
    top: 0;
    z-index: 201;
  }
`
